import React, { type LegacyRef } from 'react'

import Button from '@/shared/components/button/Button'
import Input from '@/shared/components/input/Input'
import { Caption, Text } from '@/shared/components/typography'

type PurchaseCarNumProps = {
  phoneValue: string
  errorText: string
  onChangePhoneNum: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  onClick?: () => void
  authNumberValue: string
  onChangeAuthNum: (e: React.ChangeEvent<HTMLInputElement>) => void
  isSend: boolean
  onClickRetryAuthCode: () => void
  expirationTime: React.ReactNode
  seconds: number
  isAuth: boolean | null
  autoFocus: boolean
  isValidate: boolean
  contentHeight: number
  footerRef: LegacyRef<HTMLDivElement>
  requestAuthCodeAgain: () => void
  onClickPhoneNextBtn: () => void
  handleSendAuthCode: () => void
}

const PurchasePhoneNum = ({
  phoneValue,
  errorText,
  onChangePhoneNum,
  authNumberValue,
  onChangeAuthNum,
  isSend,
  isAuth,
  seconds,
  expirationTime,
  autoFocus,
  isValidate,
  contentHeight,
  footerRef,
  requestAuthCodeAgain,
  onClickPhoneNextBtn,
  handleSendAuthCode
}: PurchaseCarNumProps) => {
  return (
    <>
      <div className={`flex flex-1 justify-center`} style={{ height: contentHeight, overflow: 'scroll' }}>
        <div className="flex w-full flex-col items-center bg-010 px-4 pt-4">
          <Text level="text1" color="text090" weight="bold">
            휴대폰 번호를 입력해 주세요.
          </Text>
          <div className="mb-[9px] mt-10 flex w-full flex-col gap-2">
            <Text level="text3" color="text090">
              휴대폰 번호
            </Text>
            <Input
              className={`border-b-[1px] border-060 pb-2 ${
                phoneValue.length ? 'font-medium' : 'font-regular'
              } leading-26 focus:border-main-050`}
              value={phoneValue}
              placeholder={'숫자만 입력해 주세요.'}
              onChange={onChangePhoneNum}
              autoFocus={autoFocus}
              length={11}
              mode="numeric"
            />
            {!isValidate && phoneValue.length === 11 && (
              <Caption level="caption2" color="caution070">
                010으로 시작하는 휴대폰 번호를 입력해 주세요.
              </Caption>
            )}
          </div>
          {isSend && (
            <div className="mt-6 flex w-full flex-col gap-2">
              <Text level="text3" color="text090">
                인증번호
              </Text>
              <div className="relative">
                <Input
                  className={`border-b-[1px] border-060 pb-2 ${
                    authNumberValue.length ? 'font-medium' : 'font-regular'
                  } leading-26 focus:border-main-050`}
                  value={authNumberValue}
                  placeholder="0000"
                  onChange={onChangeAuthNum}
                  length={4}
                  autoFocus={false}
                  mode="numeric"
                />
                {isSend && (
                  <Caption
                    level="caption1"
                    className={`absolute right-1 top-2/4 -translate-y-2/4 ${
                      seconds === 0 ? 'text-caution-070' : 'text-main-050'
                    }`}
                  >
                    {expirationTime}
                  </Caption>
                )}
              </div>
              {isAuth === false && (
                <Caption level="caption2" color="caution070">
                  {errorText}
                </Caption>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="sticky bottom-0" ref={footerRef}>
        <div className="flex w-full flex-col items-center gap-3 bg-010 px-4 py-3">
          {isSend && (
            <div onClick={requestAuthCodeAgain} className="cursor-pointer">
              <Caption level="caption1" color="text090" style="underline">
                인증 번호 다시 받기
              </Caption>
            </div>
          )}
          <Button
            text={isSend ? '다음' : '인증번호 받기'}
            color="text010"
            background="bg030"
            className="body-1 h-[56px]"
            pyValue="py-0"
            disabled={isSend ? !(authNumberValue.length === 4) : !(phoneValue.length === 11 && isValidate)}
            onClick={isSend ? onClickPhoneNextBtn : handleSendAuthCode}
          />
        </div>
      </div>
    </>
  )
}

export default PurchasePhoneNum
